var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"text-center"},[_c('div',{staticClass:"box-content"},[_c('p',[_vm._v("\n      "+_vm._s(_vm.$t('WAITING_FOR_GRAPH_AUTHENTICATION', { appHostName: _vm.teams.name }))+"  \n    ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }